import { createFileRoute } from "@tanstack/react-router";
import ExperimentsPage from "../pages/Experiments";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/experiments/")({
  component: ExperimentsRoute,
});

function ExperimentsRoute() {
  return (
    <RequireAuth require="experimentsManage">
      <ExperimentsPage />
    </RequireAuth>
  );
}
